import { GridPinnedColumns, GridColumnsState } from '@mui/x-data-grid-pro';
import { ById } from 'common/types';
import { merge } from 'lodash';

export const getColumnWidths = (columns: GridColumnsState): ById<number> => {
	return columns.all.reduce((result, col) => {
		const width = columns.lookup[col].width;
		if (!!width) {
			result[col] = width;
		}
		return result;
	}, {} as ById<number>);
};

export const getHiddenColumns = (columns: GridColumnsState): string[] => {
	return columns.all.filter((col) => !!columns.lookup[col].hide);
};

export const getPinnedColumns = (pinnedColumns: GridPinnedColumns): GridPinnedColumns => {
	return merge({ left: ['__check__'] }, pinnedColumns);
};
